import {createContext, useEffect, useState} from 'react';
import {useAnnouncementQueries} from "../hooks/queries/useAnnouncementQueries";
import {Button, Dialog, DialogContent, DialogTitle, MobileStepper} from "@mui/material";

export const AnnouncementContext = createContext(null)

export const AnnouncementProvider = ({children}) => {
    const {announcementsQuery, seeAnnouncementMutation, dismissAnnouncementMutation} = useAnnouncementQueries();
    const [open, setOpen] = useState(false);
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        if (!announcementsQuery.isSuccess) return;
        if (!announcementsQuery.data?.length) return;

        setSteps(announcementsQuery.data);
        setActiveStep(0);
        setOpen(true);
    }, [announcementsQuery.isSuccess]);

    const handleNext = () => {
        const current = steps[activeStep];
        seeAnnouncementMutation.mutate(current.id);


        if (activeStep === steps.length - 1) {
            setOpen(false);
        } else {
            setActiveStep(prev => prev + 1);
        }
    };


    const handleDismiss = () => {
        const current = steps[activeStep];
        dismissAnnouncementMutation.mutate(current.id);
        setOpen(false);
    };


    const current = steps[activeStep] || null;


    return (
        <AnnouncementContext.Provider value={{}}>
            {children}


            {current && (
                <Dialog
                    open={open}
                    fullWidth
                    maxWidth="lg"
                    PaperProps={{
                        style: {
                            borderRadius: '16px',
                            padding: 4,
                        },
                    }}
                    BackdropProps={{
                        style: {
                            backdropFilter: 'blur(5px)', // Apply blur effect
                            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a semi-transparent background
                        },
                    }}
                >
                    <DialogTitle>{current.title}</DialogTitle>
                    <DialogContent>
                        <div dangerouslySetInnerHTML={{__html: current.content}}/>
                        <MobileStepper
                            variant="dots"
                            steps={steps.length}
                            position="static"
                            activeStep={activeStep}
                            nextButton={
                                <Button size="small" onClick={handleNext}>
                                    {activeStep === steps.length - 1 ? 'Bezárás' : 'Következő'}
                                </Button>
                            }
                            backButton={
                                <Button size="small" onClick={handleDismiss}>
                                    Ne mutassa többet
                                </Button>
                            }
                        />
                    </DialogContent>
                </Dialog>
            )}
        </AnnouncementContext.Provider>
    );
};